var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg777(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.216 25.697H75.346V71.827H29.216z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.004 25.696H141.13400000000001V71.828H95.004z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.216 92.719H75.346V138.85H29.216z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.004 92.719H141.13400000000001V138.851H95.004z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.005 25.899H207.132V72.03H161.005z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M226.789 25.9H272.91999999999996V72.031H226.789z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.005 92.923H207.132V139.052H161.005z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M226.789 92.923H272.91999999999996V139.054H226.789z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.216 159.944H75.346V206.077H29.216z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.004 159.944H141.13400000000001V206.077H95.004z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.216 226.965H75.346V273.097H29.216z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.004 226.969H141.13400000000001V273.097H95.004z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.005 159.944H207.132V206.075H161.005z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M226.789 159.944H272.91999999999996V206.077H226.789z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.005 226.965H207.132V273.097H161.005z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M226.789 226.969H272.91999999999996V273.097H226.789z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M292.579 25.9H338.709V72.031H292.579z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M292.579 92.923H338.709V139.054H292.579z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M292.579 159.944H338.709V206.077H292.579z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M292.579 226.969H338.709V273.097H292.579z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.322 293.992H75.452V340.12H29.322z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.109 293.992H141.239V340.12H95.109z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.112 293.992H207.24V340.12H161.112z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M226.895 293.992H273.029V340.12H226.895z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M292.685 293.992H338.817V340.12H292.685z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M358.47 25.897H404.6V72.02799999999999H358.47z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M358.47 92.921H404.6V139.05200000000002H358.47z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M358.47 159.943H404.6V206.07500000000002H358.47z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M358.47 226.966H404.6V273.095H358.47z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M424.258 25.897H470.388V72.02799999999999H424.258z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M424.258 92.921H470.388V139.05200000000002H424.258z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M424.258 159.943H470.388V206.07500000000002H424.258z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M424.258 226.966H470.388V273.095H424.258z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M358.577 293.99H404.709V340.118H358.577z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M424.365 293.99H470.495V340.118H424.365z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.322 361.013H75.454V407.145H29.322z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.11 361.015H141.24V407.145H95.11z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.112 361.013H207.24V407.145H161.112z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M226.897 361.015H273.027V407.145H226.897z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M292.685 361.015H338.813V407.145H292.685z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.427 428.039H75.559V474.169H29.427z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.217 428.039H141.347V474.169H95.217z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.218 428.039H207.346V474.169H161.218z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M227.003 428.039H273.13599999999997V474.169H227.003z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M292.789 428.039H338.921V474.169H292.789z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M358.577 361.013H404.707V407.143H358.577z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M424.365 361.013H470.493V407.143H424.365z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M358.684 428.037H404.81600000000003V474.167H358.684z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M424.469 428.037H470.601V474.167H424.469z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg777);
export default __webpack_public_path__ + "static/media/777.bde9ec2b27de5c2e74f14ca4cd8b8123.svg";
export { ForwardRef as ReactComponent };